// ============================================
// utils/constants.js
// ============================================

// Route definitions
export const ROUTES = {
    HOME: '/home',
    LOGIN: '/login',
    SIGNUP: '/signup',
    SETTINGS: '/settings',
    FORGOT_PASSWORD: '/forgot-password',
    PRIVACY: '/privacy',
    TERMS: '/terms'
  };
  
  // Success messages
  export const MESSAGES = {
    PORCHLIGHT_ON: (minutes) => `Porchlight is on for ${minutes} minutes`,
    PORCHLIGHT_OFF: 'Porchlight is off',
    FRIEND_REQUEST_SENT: 'Friend request sent',
    FRIEND_REQUEST_ACCEPTED: 'Friend request accepted',
    FRIEND_REQUEST_DENIED: 'Friend request denied',
    EMAIL_VERIFICATION_SENT: 'Verification email sent. Please check your inbox.',
    EMAIL_VERIFICATION_REQUIRED: 'Please verify your email to use all features',
    PASSWORD_RESET_SENT: 'Password reset email sent. Please check your inbox.',
    PROFILE_UPDATED: 'Profile updated successfully',
    PASSWORD_CHANGED: 'Password changed successfully'
  };
  
  // Error messages
  export const ERRORS = {
    EMAIL_NOT_VERIFIED: 'Please verify your email address first',
    INVALID_EMAIL: 'Please enter a valid email address',
    PASSWORD_TOO_SHORT: 'Password must be at least 6 characters',
    PASSWORDS_DONT_MATCH: "Passwords don't match",
    REQUIRED_FIELDS: 'All fields are required',
    TOO_MANY_REQUESTS: 'Too many attempts. Please try again later.',
    NETWORK_ERROR: 'Network error. Please check your connection.',
    GENERIC_ERROR: 'An unexpected error occurred. Please try again.',
    USER_NOT_FOUND: 'No user found with that email address',
    ALREADY_FRIENDS: 'You are already friends with this user',
    FRIEND_REQUEST_EXISTS: 'Friend request already sent',
    SELF_FRIEND_REQUEST: 'You cannot send a friend request to yourself',
    // Additional errors used by UI/components
    INVALID_DURATION: 'Please enter a duration between 1 and 720 minutes',
    NO_FRIENDS_SELECTED: 'Please select at least one friend',
    OFFLINE: 'You appear to be offline. Please check your connection.',
    TIMEOUT: 'Request timed out. Please try again.',
    QUOTA_EXCEEDED: 'Rate limit or quota exceeded. Please try again later.'
  };
  
  // Porchlight duration options (in minutes)
  export const DURATION_OPTIONS = [
    { value: 15, label: '15 minutes' },
    { value: 30, label: '30 minutes' },
    { value: 60, label: '1 hour' },
    { value: 120, label: '2 hours' },
    { value: 180, label: '3 hours' },
    { value: 240, label: '4 hours' },
    { value: 360, label: '6 hours' },
    { value: 480, label: '8 hours' },
    { value: 720, label: '12 hours' }
  ];
  
  // Notification types
  export const NOTIFICATION_TYPES = {
    PORCHLIGHT_ON: 'porchlight_on',
    PORCHLIGHT_OFF: 'porchlight_off',
    FRIEND_REQUEST: 'friend_request',
    FRIEND_ACCEPTED: 'friend_accepted'
  };
  
  // App metadata
  export const APP_INFO = {
    NAME: 'Porchlight',
    VERSION: '1.0.0',
    DESCRIPTION: 'Let your friends know when you\'re available to hang out'
  };